<template src="./Products.html"></template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import ProductMenuGroupTemplate from "../common/ProductMenuGroupTemplate.vue";
import { required, requiredIf } from "vuelidate/lib/validators";
import { baseURL, imageURL } from "../../settings/settings.js";

export default {
  name: "products",
  components: { autocomplete: ProductMenuGroupTemplate },
  data() {
    return {
      showModal: false,
      product: {
        id: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
        descGe: "",
        descEn: "",
        descRu: "",
        mainImage: null,
        gallery: [],
        brandId: null,
        itemPrice: null,
        pointsPrice: null,
        pointCorrection: null,
        legalId: "",
        properties: [],
        categories: [],
        subCategories: [],
        subCategories2: [],
        hasLoyalty: null,
        loyaltyId: null,
        hasCatalog: null,
        hasMarketPlace: null,
        amountInStock: null,
      },
      organizations: {
        id: "",
        identificationCode: "",
        name: "",
        password: "",
        physicalAddress: "",
        legalAddress: "",
        mobile: "",
        email: "",
        dirFirstName: "",
        dirLastName: "",
        hasMerchant: false,
        merchantCout: 0,
        hasLoyalty: false,
      },
      productProperty: {
        id: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
      },
      productCategory: {
        id: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
      },
      productSubCategory: {
        id: null,
        categoryId: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
      },
      productSubSubCategory: {
        id: null,
        subCategory1Id: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
      },
      isActive: false,
      isEdit: true,
      selectedFile: null,
      showPreview: false,
      editImg: false,
      resetAutocomplete: false,
      imagePreview: "",
      imagePreviews: [],
      autocompleteBrandValue: "",
      editGalleryArray: [],
      productsArray: [],
      legalArray: [],
      productBrandsArray: [],
      productPropertiesArray: [],
      productCategoriesArray: [],
      productSubCategoriesArray: [],
      productSubSubCategoriesArray: [],
      mainImageUpuloadName: "Choose FIle ...",
      GalleryUpuloadName: "Choose FIle ...",
      dropDownLegal: "აირჩიეთ ორგანიზაცია",
      dropDownProductProperty: "აირჩიეთ თვისება",
      dropDownProductCategory: "აირჩიეთ კატეგორია",
      dropDownProductSubCategory: "აირჩიეთ ქვე კატეგორია",
      dropDownProductSubSubCategory: "აირჩიეთ ქვე ქვე კატეგორია",
      dropDownLoyalty: "აირჩიეთ ლოიალობის პირობა",
      fileInputKey: 0,
      isEdit: false,
      loyaltyArray: [],
      categoryWithChildCategoriesForNew: [],
      filteredDataArray: [],
      searchText: null,
    };
  },
  validations: {
    product: {
      nameGe: {
        required,
      },
      nameEn: {
        required,
      },
      nameRu: {
        required,
      },
      descGe: {
        required,
      },
      descEn: {
        required,
      },
      descRu: {
        required,
      },
      itemPrice: {
        required,
      },
      pointCorrection: {
        required: requiredIf(function (product) {
          return this.product.hasCatalog || this.product.hasMarketPlace;
        }),
      },
      loyaltyId: {
        required: requiredIf(function (product) {
          return this.product.hasLoyalty;
        }),
      },
      hasCatalog: {
        required: requiredIf(function (product) {
          return !this.product.hasLoyalty && !this.product.hasMarketPlace;
        }),
      },
      hasLoyalty: {
        required: requiredIf(function (product) {
          return !this.product.hasCatalog && !this.product.hasMarketPlace;
        }),
      },
      hasMarketPlace: {
        required: requiredIf(function (product) {
          return !this.product.hasCatalog && !this.product.hasLoyalty;
        }),
      },
      legalId: {
        required,
      },
      brandId: {
        required,
      },
      properties: {
        required,
      },
      amountInStock: {
        required,
      },
    },
  },
  async created() {
    let productResult = await this.$http.getProduct();
    this.productsArray = productResult.data.res;
    this.filteredDataArray = this.productsArray;

    let legalResult = await this.$http.getLegal();
    this.legalArray = legalResult.data.res;

    let productPropertyResult = await this.$http.getProductProperty();
    this.productPropertiesArray = productPropertyResult.data.res;

    let productCategoryResult = await this.$http.getProductCategory();
    this.productCategoriesArray = productCategoryResult.data.res;

    let productBrandResult = await this.$http.getProductBrand();
    this.productBrandsArray = productBrandResult.data.res;

    let productLoyaltiesResult = await this.$http.getProductLoyalties();
    this.loyaltyArray = productLoyaltiesResult.data.res;
  },
  methods: {
    async addOrEditProduct() {
      if (!this.isEdit) await this.addProduct();
      else await this.editProduct();
    },
    async addProduct() {
      try {
        let data = new FormData();

        data.append("nameGe", this.product.nameGe);
        data.append("nameEn", this.product.nameEn);
        data.append("nameRu", this.product.nameRu);
        data.append("descGe", this.product.descGe);
        data.append("descEn", this.product.descEn);
        data.append("descRu", this.product.descRu);
        data.append("itemPrice", this.product.itemPrice);
        data.append("brandId", this.product.brandId);
        data.append("pointCorrection", this.product.pointCorrection);
        data.append("legalId", this.product.legalId);
        data.append("properties", this.product.properties);
        //data.append("categories", this.product.categories);
        //data.append("subCategories", this.product.subCategories);
        data.append("mainImage", this.product.mainImage);

        data.append("hasLoyalty", this.product.hasLoyalty);
        data.append("hasCatalog", this.product.hasCatalog);
        data.append("hasMarketPlace", this.product.hasMarketPlace);
        data.append("loyaltyId", this.product.loyaltyId);
        data.append("amountInStock", this.product.amountInStock);

        if (this.categoryWithChildCategoriesForNew != 0) {
          this.categoryWithChildCategoriesForNew.forEach((el) => {
            data.append(
              "ProductProdCategoryDetailesSerialized",
              JSON.stringify({
                CategoryId: el.categoryId,
                SubCategory1Id: el.subCategory1Id,
                SubCategory2Id: el.subCategory2Id,
              })
            );
          });
        }

        this.product.gallery.forEach((el) => {
          data.append("gallery", el);
        });
        let productAddResult = await this.$http.postProduct(data);
        if (productAddResult.data.resultCode === "200") {
          bus.$emit("success", "პროდუქტი წარმატებით დაემატა");
          let productResult = await this.$http.getProduct();
          this.productsArray = productResult.data.res;
        } else {
          bus.$emit("warning", "პროდუქტის დამატების დროს მოხდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editProduct() {
      try {
        var data = new FormData();

        data.append("id", this.product.id);
        data.append("nameGe", this.product.nameGe);
        data.append("nameEn", this.product.nameEn);
        data.append("nameRu", this.product.nameRu);
        data.append("descGe", this.product.descGe);
        data.append("descEn", this.product.descEn);
        data.append("descRu", this.product.descRu);
        data.append("itemPrice", this.product.itemPrice);
        data.append("brandId", this.product.brandId);
        data.append("pointCorrection", this.product.pointCorrection);
        data.append("legalId", this.product.legalId);
        data.append("properties", this.product.properties);
        data.append("categories", this.product.categories);
        data.append("subCategories", this.product.subCategories);
        data.append("mainImage", this.product.mainImage);

        data.append("hasLoyalty", this.product.hasLoyalty);
        data.append("hasCatalog", this.product.hasCatalog);
        data.append("hasMarketPlace", this.product.hasMarketPlace);
        data.append("loyaltyId", this.product.loyaltyId);
        data.append("amountInStock", this.product.amountInStock);

        this.editGalleryArray.forEach((el) => {
          data.append("gallery", el);
        });
        let productEditResult = await this.$http.putProduct(data);
        if (productEditResult.data.resultCode === "200") {
          bus.$emit("success", "პროდუქტი წარმატებით დარედაქტირდა");
          this.editGalleryArray = [];
          this.mainImageUpuloadName = "Choose FIle ...";
          this.editImg = false;
          let productResult = await this.$http.getProduct();
          this.productsArray = productResult.data.res;
        } else {
          bus.$emit("warning", "პროდუქტის რედაქტირების დროს მოხდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async deleteProduct() {
      try {
        let deleteIndex = this.productsArray.findIndex(
          (d) => d.id === this.product.id
        );
        let productDeleteResult = await this.$http.deleteProduct(
          this.product.id
        );
        if (productDeleteResult.data.resultCode === "200") {
          bus.$emit("success", "პროდუქტი წარმატებით წაიშალა");
          this.productsArray.splice(deleteIndex, 1);
        } else {
          bus.$emit("warning", "პროდუქტის წაშლის დროს მოხდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editFillInputs(row) {
      let fillEditProduct = await this.$http.getByIDProductWithGallery(row.id);
      this.product = Object.assign({}, fillEditProduct.data.res);
      this.product.mainImage = row.mainImage;
      this.dropDownLegal = this.getLegalName(row.legalId);
      this.dropDownLoyalty = this.getLoyaltyName(row.loyaltyId);
      this.mainImageUpuloadName = row.mainImage;
      //for (let i = 0; i < this.product.categories.length; i++) {
      //this.getProductSubCategory(this.product.categories[i]);
      //}
      //for (let j = 0; j < this.product.subCategories.length; j++) {
      //this.getProductSubSubCategory(this.product.subCategories[j]);
      //}
      this.categoryWithChildCategoriesForNew =
        this.product.productProdCategoryDetailes;
      this.getBrandName();
      this.imagePreview = imageURL + this.product.mainImage;
      this.showPreview = true;

      for (let i = 0; i < this.product.gallery.length; i++) {
        this.imagePreviews.push(imageURL + this.product.gallery[i].imageSrc);
      }

      this.isEdit = true;
    },
    getDeleteId(id) {
      this.product.id = id;
    },
    dropDownLegalClick(legalName, legalId) {
      this.dropDownLegal = legalName;
      this.organizations.name = legalName;
      this.organizations.id = legalId;
      this.product.legalId = legalId;
    },
    dropDownLoyaltyClick(name, id) {
      this.dropDownLoyalty = name;
      //this.organizations.name = name;
      //this.organizations.id = id;
      this.product.loyaltyId = id;
    },
    dropDownPropertyClick(productPropertyName, propertyId) {
      this.dropDownProductProperty = productPropertyName;
      this.productProperty.nameGe = productPropertyName;
      this.productProperty.id = propertyId;
    },
    async dropDownCategoryClick(productCategoryName, categoryId) {
      this.dropDownProductCategory = productCategoryName;
      this.productCategory.nameGe = productCategoryName;
      this.productCategory.id = categoryId;

      //SubCategory
      this.dropDownProductSubCategory = "აირჩიეთ ქვე კატეგორია";
      this.productSubCategoriesArray = [];
      this.productSubCategory.id = null;
      await this.getProductSubCategory(categoryId);

      //SubSubCategory
      this.dropDownProductSubSubCategory = "აირჩიეთ ქვე ქვე კატეგორია";
      this.productSubSubCategoriesArray = [];
      this.productSubSubCategory.id = null;
    },
    async dropDownSubCategoryClick(productSubCategoryName, subCategoryId) {
      this.dropDownProductSubCategory = productSubCategoryName;
      this.productSubCategory.nameGe = productSubCategoryName;
      this.productSubCategory.id = subCategoryId;

      //SubSubCategory
      this.dropDownProductSubSubCategory = "აირჩიეთ ქვე ქვე კატეგორია";
      this.productSubSubCategoriesArray = [];
      this.productSubSubCategory.id = null;
      await this.getProductSubSubCategory(subCategoryId);
    },
    dropDownSubSubCategoryClick(
      productSubSubCategorySubName,
      subSubCategoryId
    ) {
      this.dropDownProductSubSubCategory = productSubSubCategorySubName;
      this.productSubSubCategory.nameGe = productSubSubCategorySubName;
      this.productSubSubCategory.id = subSubCategoryId;
    },
    async getProductSubCategory(categoryId) {
      let productSubCategoryResult = await this.$http.getProductSubCategory({
        lang: "ka-GE",
        id: categoryId,
      });
      this.productSubCategoriesArray = [];
      for (let i = 0; i < productSubCategoryResult.data.res.length; i++) {
        this.productSubCategoriesArray.push(
          productSubCategoryResult.data.res[i]
        );
      }
    },
    async getProductSubSubCategory(subSubCategoryId) {
      let productSubSubCategoryResult =
        await this.$http.getProductSubSubCategory({ id: subSubCategoryId });
      this.productSubSubCategoriesArray = [];
      for (let i = 0; i < productSubSubCategoryResult.data.res.length; i++) {
        if (
          this.productSubSubCategoriesArray[i] !==
          productSubSubCategoryResult.data.res[i]
        ) {
          this.productSubSubCategoriesArray.push(
            productSubSubCategoryResult.data.res[i]
          );
        }
      }
    },
    addProperty() {
      if (this.productProperty.id === null) {
        bus.$emit("warning", "გთხოვთ აირჩიოთ თვისებები");
        return;
      }
      let found = this.product.properties.some((el) => {
        return el === this.productProperty.id;
      });
      if (!found) {
        this.product.properties.push(this.productProperty.id);
      } else {
        console.log("მსგავსი ჩანაწერი უკვე არის დამატებული");
      }
    },
    async addCategoryWithChildCategories() {
      //ვალიდაცები
      if (this.productCategory.id === null) {
        bus.$emit("warning", "გთხოვთ აირჩიოთ კატეგორია");
        return;
      }
      if (
        this.productSubCategoriesArray != 0 &&
        this.productSubCategory.id === null
      ) {
        bus.$emit("warning", "გთხოვთ აირჩიოთ ქვე კატეგორია");
        return;
      }
      if (
        this.productSubSubCategoriesArray != 0 &&
        this.productSubSubCategory.id === null
      ) {
        bus.$emit("warning", "გთხოვთ აირჩიოთ ქვე ქვე კატეგორი");
        return;
      }

      if (!this.isEdit) {
        this.categoryWithChildCategoriesForNew.push({
          key: Date.now(),
          categoryId: this.productCategory.id,
          subCategory1Id: this.productSubCategory.id,
          subCategory2Id: this.productSubSubCategory.id,
        });
      } else {
        let addProductCategoryDetailResult =
          await this.$http.addProductCategoryDetail({
            productId: this.product.id,
            categoryId: this.productCategory.id,
            subCategory1Id: this.productSubCategory.id,
            subCategory2Id: this.productSubSubCategory.id,
          });
        if (addProductCategoryDetailResult.data.resultCode.status === "200") {
          bus.$emit("success", "კატეგორია დაემატა წარმატებით");
          let _dt =
            addProductCategoryDetailResult.data.resultCode
              .productProdCategoryDetail;
          this.categoryWithChildCategoriesForNew.push({
            id: _dt.id,
            categoryId: _dt.categoryId,
            subCategory1Id: _dt.subCategory1Id,
            subCategory2Id: _dt.subCategory2Id,
            subCategory1Name: _dt.subCategory1Name,
            subCategory2Name: _dt.subCategory2Name,
          });
        } else {
          bus.$emit("warning", "კატეგორია წაშლის დროს მოხდა შეცდომა");
        }
      }
      //გასუფთავება
      this.dropDownProductCategory = "აირჩიეთ კატეგორია";
      this.dropDownProductSubCategory = "აირჩიეთ ქვე კატეგორია";
      this.dropDownProductSubSubCategory = "აირჩიეთ ქვე ქვე კატეგორია";
    },
    addSubCategory() {
      if (this.productSubCategory.id === null) {
        bus.$emit("warning", "გთხოვთ აირჩიოთ ქვე კატეგორია");
        return;
      }
      let found = this.product.subCategories.some((el) => {
        return el === this.productSubCategory.id;
      });
      if (!found) {
        this.product.subCategories.push(this.productSubCategory.id);
        this.getProductSubSubCategory(this.productSubCategory.id);
      } else {
        console.log("მსგავსი ჩანაწერი უკვე არის დამატებული");
      }
    },
    addSubSubCategory() {
      if (this.productSubSubCategory.id === null) {
        bus.$emit("warning", "გთხოვთ აირჩიოთ ქვე ქვე კატეგორია");
        return;
      }
      let found = this.product.subCategories2.some((el) => {
        return el === this.productSubSubCategory.id;
      });
      if (!found) {
        this.product.subCategories2.push(this.productSubSubCategory.id);
      } else {
        console.log("მსგავსი ჩანაწერი უკვე არის დამატებული");
      }
    },
    getPropertyName(id) {
      let propertyIndex = this.productPropertiesArray.findIndex(
        (d) => d.id === id
      );
      return this.productPropertiesArray[propertyIndex].nameGe;
    },
    getCategoryName(id) {
      let categoryIndex = this.productCategoriesArray.findIndex(
        (d) => d.id === id
      );
      return this.productCategoriesArray[categoryIndex].nameGe;
    },
    getSubCategoryName(id) {
      let subCategoryIndex = this.productSubCategoriesArray.findIndex(
        (d) => d.subCategoryId === id
      );
      if (subCategoryIndex === -1) {
        return;
      }
      return this.productSubCategoriesArray[subCategoryIndex].name;
    },
    getSubSubCategoryName(id) {
      let subSubCategoryIndex = this.productSubSubCategoriesArray.findIndex(
        (d) => d.subCategory2Id === id
      );
      if (subSubCategoryIndex === -1) {
        return;
      }
      return this.productSubSubCategoriesArray[subSubCategoryIndex].name;
    },
    getLegalName(id) {
      let legalIndex = this.legalArray.findIndex((d) => d.id === id);
      if (legalIndex !== -1) {
        return this.legalArray[legalIndex].name;
      }
    },
    getLoyaltyName(id) {
      let legalIndex = this.loyaltyArray.findIndex((d) => d.id === id);
      if (legalIndex !== -1) {
        return this.loyaltyArray[legalIndex].name;
      }
    },
    removePropertyFormList(id) {
      let properyIndex = this.product.properties.findIndex((d) => d === id);
      this.product.properties.splice(properyIndex, 1);
    },
    async removeCategoryFormList(id) {
      if (!this.isEdit) {
        let index = this.categoryWithChildCategoriesForNew.findIndex(
          (d) => d.key === id
        );
        this.categoryWithChildCategoriesForNew.splice(index, 1);
      } else {
        let deleteProductCategoryDetailResult =
          await this.$http.deleteProductCategoryDetail(id);

        if (deleteProductCategoryDetailResult.data.resultCode === "200") {
          bus.$emit("success", "კატეგორია წაიშალა წარმატებით");
          let categoryIndex = this.categoryWithChildCategoriesForNew.findIndex(
            (d) => d.id === id
          );
          this.categoryWithChildCategoriesForNew.splice(categoryIndex, 1);
          //this.clearItemsOnCategoryDelete(id);
        } else {
          bus.$emit("warning", "კატეგორია წაშლის დროს მოხდა შეცდომა");
        }
      }
    },
    removeSubCategoryFormList(id) {
      let subCategoryIndex = this.product.subCategories.findIndex(
        (d) => d === id
      );
      this.product.subCategories.splice(subCategoryIndex, 1);
      this.clearItemsOnSubCategoryDelete(id);
    },
    removeSubSubCategoryFormList(id) {
      let subCategory2Index = this.product.subCategories2.findIndex(
        (d) => d === id
      );
      this.product.subCategories2.splice(subCategory2Index, 1);
    },
    clearItemsOnCategoryDelete(categoryId) {
      this.productSubCategoriesArray = this.productSubCategoriesArray.filter(
        (d) => d.categoryId !== categoryId
      );
    },
    clearItemsOnSubCategoryDelete(subCategoryId) {
      this.productSubSubCategoriesArray =
        this.productSubSubCategoriesArray.filter(
          (d) => d.subCategory1Id !== subCategoryId
        );
    },
    async cancelClick() {
      let productResult = await this.$http.getProduct();
      this.productsArray = productResult.data.res;
    },
    async onFileSelected() {
      if (this.isEdit) {
        await this.onFileSelectedOnEdit();
      } else {
        this.mainImageUpuloadName = this.$refs.file.files[0].name;
        this.product.mainImage = this.$refs.file.files[0];
        let reader = new FileReader();
        reader.addEventListener(
          "load",
          function () {
            this.showPreview = true;
            this.imagePreview = reader.result;
          }.bind(this),
          false
        );
        if (this.product.mainImage) {
          if (/\.(jpe?g|png|gif)$/i.test(this.product.mainImage.name)) {
            reader.readAsDataURL(this.product.mainImage);
          }
        }
      }
    },
    async onFileSelectedOnEdit() {
      let data = new FormData();
      data.append("ProductId", this.product.id);
      data.append("Image", this.$refs.file.files[0]);

      let changeProductMainImageResult =
        await this.$http.changeProductMainImage(data);

      if (changeProductMainImageResult.data.resultCode === "200") {
        bus.$emit("success", "სურათი შეიცვალა წარმატებით");
        let fillEditProduct = await this.$http.getByIDProduct(this.product.id);
        this.product.mainImage = fillEditProduct.data.res.mainImage;
        this.mainImageUpuloadName = this.product.mainImage;
      } else {
        bus.$emit("warning", "სურათის შეცვლის დროს მოხდა შეცდომა");
      }
    },
    async onFileSelectedGallery() {
      //თუ Edit არის ეგრევე იტვირთება
      if (this.isEdit) {
        await this.onFileSelectedGalleryOnEdit();
      } else {
        for (let i = 0; i < this.$refs.fileGallery.files.length; i++) {
          this.product.gallery.push(this.$refs.fileGallery.files[i]);
        }
        for (let i = 0; i < this.product.gallery.length; i++) {
          let reader = new FileReader();
          reader.addEventListener(
            "load",
            function () {
              this.$refs["image" + parseInt(i)][0].src = reader.result;
            }.bind(this),
            false
          );
          if (this.product.gallery[i]) {
            if (/\.(jpe?g|png|gif)$/i.test(this.product.gallery[i].name)) {
              reader.readAsDataURL(this.product.gallery[i]);
            }
          }
        }
      }
    },
    async onFileSelectedGalleryOnEdit() {
      this.editGalleryArray = [];
      for (let i = 0; i < this.$refs.fileGallery.files.length; i++) {
        this.editGalleryArray.push(this.$refs.fileGallery.files[i]);
      }

      let data = new FormData();
      data.append("ProductId", this.product.id);
      this.editGalleryArray.forEach((el) => {
        data.append("Image", el);
      });

      let addProductGalleryImageResult =
        await this.$http.addProductGalleryImage(data);

      if (addProductGalleryImageResult.data.resultCode === "200") {
        bus.$emit("success", "სურათი წარმატებით დაემატა");

        let producGallerytResult = await this.$http.getByIDProductGallery(
          this.product.id
        );
        this.product.gallery = producGallerytResult.data.res;
      } else {
        bus.$emit("warning", "სურათის დამატების დროს მოხდა შეცდომა");
      }
    },
    async removeFileFormList(id) {
      let addProductGalleryImageResult =
        await this.$http.deleteProductGalleryImage({ id: id });
      return;

      let galleryIndex = this.product.gallery.findIndex((d) => d.name === name);
      this.product.gallery.splice(galleryIndex, 1);
      for (let i = 0; i < this.product.gallery.length; i++) {
        let reader = new FileReader();
        reader.addEventListener(
          "load",
          function () {
            this.$refs["image" + parseInt(i)][0].src = reader.result;
          }.bind(this),
          false
        );
        if (this.product.gallery[i]) {
          if (/\.(jpe?g|png|gif)$/i.test(this.product.gallery[i].name)) {
            reader.readAsDataURL(this.product.gallery[i]);
          }
        }
      }
    },
    async removeFileFormListOnEdit(id) {
      let galleryIndex = this.product.gallery.findIndex((d) => d.id === id);
      if (galleryIndex !== -1) {
        this.product.gallery.splice(galleryIndex, 1);
        let galleryDeleteResult = await this.$http.deleteProductGalleryImage({
          id: id,
        });
        if (galleryDeleteResult.data.resultCode === "200") {
          bus.$emit("success", "სურათი წარმატებით წაიშალა");
        } else {
          bus.$emit("warning", "სურათის წაშლის დროს მოხდა შეცდომა");
        }
      }
    },
    imageUrl1(mainImageUpuloadName) {
      if (mainImageUpuloadName !== "Choose FIle ...") {
        return imageURL + mainImageUpuloadName;
      }
    },
    onAutocompleteInput(object) {
      this.product.brandId = object.id;
    },
    async getBrandName() {
      let productBrandByIDResult = await this.$http.getByIDProductBrand(
        this.product.brandId
      );
      //this.resetAutocomplete = !this.resetAutocomplete;

      this.autocompleteBrandValue = productBrandByIDResult.data.res.name;
    },
    modalPrepare() {
      this.isActive = true;
    },
    hasCatalogClick() {
      if (!this.product.hasCatalog) this.product.hasCatalog = null;
    },
    hasLoyaltyClick() {
      if (!this.product.hasLoyalty) this.product.hasLoyalty = null;
    },
    hasMarketPlaceClick() {
      if (!this.product.hasMarketPlace) this.product.hasMarketPlace = null;
    },

    editClear() {
      this.isEdit = true;
      this.editGalleryArray = [];
    },
    searchData() {
      this.filteredDataArray = this.productsArray.filter(
        (item) =>
          item.nameGe.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
      );
    },
    clearData() {
      this.product.id = null;
      this.product.nameGe = "";
      this.product.nameEn = "";
      this.product.nameRu = "";
      this.product.descGe = "";
      this.product.descEn = "";
      this.product.descRu = "";
      this.product.itemPrice = null;
      this.product.pointCorrection = null;
      this.product.legalId = "";
      this.product.properties = [];
      this.product.categories = [];
      this.product.subCategories = [];
      this.product.subCategories2 = [];
      this.productProperty.id = null;
      this.productProperty.nameGe = "";
      this.productProperty.nameEn = "";
      this.productProperty.nameRu = "";
      this.productCategory.id = null;
      this.productCategory.nameGe = "";
      this.productCategory.nameEn = "";
      this.productCategory.nameRu = "";
      this.productSubCategory.id = null;
      this.productSubCategory.categoryId = null;
      this.productSubCategory.nameGe = "";
      this.productSubCategory.nameEn = "";
      this.productSubCategory.nameRu = "";
      this.productSubSubCategory.id = null;
      this.productSubSubCategory.subCategory1Id = null;
      this.productSubSubCategory.nameGe = "";
      this.productSubSubCategory.nameEn = "";
      this.productSubSubCategory.nameRu = "";
      this.productSubCategoriesArray = [];
      this.productSubSubCategoriesArray = [];
      this.dropDownLegal = "აირჩიეთ ორგანიზაცია";
      this.dropDownProductProperty = "აირჩიეთ თვისება";
      this.dropDownProductCategory = "აირჩიეთ კატეგორია";
      this.dropDownProductSubCategory = "აირჩიეთ ქვე კატეგორია";
      this.dropDownProductSubSubCategory = "აირჩიეთ ქვე ქვე კატეგორია";
      this.mainImageUpuloadName = "Choose FIle ...";
      this.GalleryUpuloadName = "Choose FIle ...";
      this.product.mainImage = null;
      this.product.gallery = [];
      this.$refs.file.value = null;
      this.showPreview = false;
      this.imagePreview = null;
      this.editGalleryArray = [];
      this.product.brandId = "";
      this.autocompleteBrandValue = "";
      this.resetAutocomplete = !this.resetAutocomplete;

      this.dropDownLoyalty = "აირჩიეთ ლოიალობის პირობები";
      this.product.loyaltyId = null;
      this.product.hasLoyalty = null;
      this.product.hasCatalog = null;
      this.product.hasMarketPlace = null;
      this.product.amountInStock = null;

      this.fileInputKey++;
      this.isEdit = false;
      this.$v.$reset();
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";
</style>



// WEBPACK FOOTER //
// src/components/view/Products.vue